import "./App.css";
import "react-loading-skeleton/dist/skeleton.css";
import React, { Suspense } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Routes } from "react-router";
import { ToastAlert } from "conponents/ToastAlert";

const Home = React.lazy(() => import("./container/HomeContainer"));
const Menu = React.lazy(() => import("./container/MenuContainer"));
const Product = React.lazy(() => import("./container/Product"));
const Basket = React.lazy(() => import("./container/BasketContainer"));
const GuestInfo = React.lazy(() => import("./container/GuestInfoContainer"));
const Payment = React.lazy(() => import("./container/PaymentContainer"));
const PaymentInfo = React.lazy(() =>
  import("./container/PaymentInfoContainer")
);
const DivideBill = React.lazy(() => import("./container/DivideBillContainer"));
const CustomBill = React.lazy(() => import("./container/CustomAmount"));

function App() {
  return (
    <>
      <ToastAlert />
      <Suspense fallback={<div className="loading" />}>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/basket" element={<Basket />} />
            <Route path="/guestinfo" element={<GuestInfo />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/paymentInfo" element={<PaymentInfo />} />
            <Route path="/divideBill" element={<DivideBill />} />
            <Route path="/customBill" element={<CustomBill />} />
            <Route path="/menu/product" element={<Product />} />
          </Routes>
        </Router>
      </Suspense>
    </>
  );
}

export default App;
